exports = module.exports = require(29);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require(31);
exports.Duplex = require(27);
exports.Transform = require(30);
exports.PassThrough = require(28);
